module.exports = "/packs/course-web-marketing-bd839a491f25107d2672c69d3abaa878.png";